import supportPage from '@epi-assets/content/supportPage.json';

export function getSupportContent() {
  return supportPage;
}
